import moment from '@e3dc-react/shell/Libs/moment'
import { InstallationHistoryDto } from '../dto/installation-history.dto'
import { InstallationHistory } from '../models/installation-history.model'

export const fromDtoToInstallationHistoryConverter = (dto: InstallationHistoryDto): InstallationHistory => {
  return { ...dto, timestamp: moment(dto.timestamp) }
}
